// src/pages/Privacy.js
import React from "react";
import "./LegalPages.css";

const Privacy = () => {
  return (
    <div className="legal-container">
      <h1>Privacy Policy</h1>
      <p><strong>Effective Date:</strong> 01/10/2025</p>

      <p>
        At <strong>Gyanexia</strong>, we value and respect your privacy. This Privacy Policy explains how we collect,
        use, and protect your personal information when you access or use our website, mobile app, and related services.
      </p>

      <p>
        By using Gyanexia, you agree to the terms of this Privacy Policy.
      </p>

      <h3>1. Information We Collect</h3>

      <p><strong>a) Personal Information:</strong></p>
      <ul>
        <li>Name and contact information (phone number, email address)</li>
        <li>Class, school name, and city</li>
        <li>Parent/guardian details (for students under 18)</li>
        <li>Payment details (processed securely through third-party gateways)</li>
        <li>Uploaded documents or images (if required for verification or registration)</li>
      </ul>

      <p><strong>b) Automatically Collected Information:</strong></p>
      <ul>
        <li>IP address and browser type</li>
        <li>Device and operating system information</li>
        <li>Usage data (pages visited, time spent, etc.)</li>
        <li>Cookies and similar tracking technologies to enhance user experience</li>
      </ul>

      <h3>2. How We Use Your Information</h3>
      <ul>
        <li>Process registrations and verify student eligibility</li>
        <li>Provide educational content, classes, and updates</li>
        <li>Communicate important announcements, offers, or changes</li>
        <li>Improve our website, app, and services through analytics</li>
        <li>Ensure compliance with our terms and legal obligations</li>
      </ul>

      <h3>3. Disclosure of Information</h3>
      <p>
        We <strong>do not sell or rent</strong> your personal data to any third party.
        However, we may share limited information with trusted partners such as:
      </p>
      <ul>
        <li><strong>Payment gateways</strong> (for secure fee transactions)</li>
        <li><strong>Educational or event partners</strong> (for course coordination)</li>
        <li><strong>Technology service providers</strong> (for hosting and analytics)</li>
      </ul>
      <p>
        All third parties are bound by confidentiality and data protection agreements.
      </p>

      <h3>4. Data Security</h3>
      <p>
        We implement appropriate security measures, including encryption and secure servers,
        to safeguard your data against unauthorized access, alteration, or disclosure.
      </p>

      <h3>5. Your Rights</h3>
      <ul>
        <li>Request access or correction of your personal information</li>
        <li>Withdraw consent for data use (subject to legal or contractual restrictions)</li>
        <li>Request deletion of your account or stored data</li>
      </ul>
      <p>
        For such requests, please contact us at <strong>gyanexia@gmail.com</strong>.
      </p>

      <h3>6. Data Retention</h3>
      <p>
        We retain personal information only as long as necessary to fulfill the purpose for which it was collected
        or as required by law.
      </p>

      <h3>7. Policy Updates</h3>
      <p>
        This Privacy Policy may be updated from time to time. Any changes will be posted on this page with an updated “Effective Date.”
      </p>

      <h3>8. Contact Us</h3>
      <p>
        If you have any questions about this Privacy Policy, please contact us:
      </p>
      <ul>
        <li><strong>Email:</strong> gyanexia@gmail.com</li>
        <li><strong>Phone:</strong> +91 8840284749</li>
        
      </ul>
    </div>
  );
};

export default Privacy;
